import ErrorManager from '@/common/utils/ErrorManager';
import { Site } from '@/models/Site';
import { ERROR } from '@/modules/ErrorToaster/store/mutation-types';
import { RootState } from '@/plugins/store';
import { ActionTree, Commit } from 'vuex';
import SiteListService, { SiteListPayload } from '../service/SiteListService';
import { SiteListActions } from './action-types';
import { SITE_LIST } from './mutation-types';
import { SiteListState } from './state';


interface SiteListActionType {
    commit: Commit;
    state: SiteListState;
}



export const actions: ActionTree<SiteListState, RootState> = {
    async [SiteListActions.GET_SITE_LIST](
        { commit }: SiteListActionType,
        payload: SiteListPayload
    ): Promise<void> {
        commit(SITE_LIST.SET_PAGE, payload.page);
        commit(SITE_LIST.SET_LOADING, true);
        await SiteListService.getSiteList(payload)
            .then(async (response: any) => {
                if (response !== undefined || response.status !== undefined) {
                    if (response.status !== 200) {
                        commit(SITE_LIST.SET_ERROR, true);
                        commit(SITE_LIST.SET_LOADING, false);
                        commit(
                            `errorToaster/${ERROR.SET_MESSAGE}`,
                            await ErrorManager.processErrorCustomMessage(
                                response.status,
                                'app.error.undefined'
                            ),
                            { root: true }
                        );
                    }
                    const sitetListData: Site[] = response.data;
                    if (payload.page === 0) {
                        commit(SITE_LIST.SET_SCROLL, 0);
                        commit(SITE_LIST.SET_ITEMS, sitetListData);
                    } else {
                        commit(SITE_LIST.ADD_ITEMS, sitetListData);
                    }
                    commit(SITE_LIST.SET_PAGES, parseInt(response.headers.pages) || 0);
                    commit(SITE_LIST.SET_LOADING, false);
                } else {
                    commit(SITE_LIST.SET_ERROR, true);
                    commit(SITE_LIST.SET_LOADING, false);
                    commit(
                        `errorToaster/${ERROR.SET_MESSAGE}`,
                        await ErrorManager.processErrorCustomMessage(
                            response.status,
                            'app.error.undefined'
                        ),
                        { root: true }
                    );
                }
            })
            .catch(async error => {
                commit(SITE_LIST.SET_ERROR, true);
                commit(SITE_LIST.SET_LOADING, false);
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processError(error),
                    { root: true }
                );
            });
    },
    async loadSites({ dispatch }) {
        const payload = {
            page: 0,
            filter: '',
        };
        await dispatch(SiteListActions.GET_SITE_LIST, payload);
    },
    async loadSitesFiltresParSociete({ dispatch }, societeId: number) {
        const payload = {
            page: 0,
            filter: '',
            societeId: societeId
        };
        await dispatch(SiteListActions.GET_SITE_LIST, payload);
    },
    [SiteListActions.RESET_LIST]({ commit }: SiteListActionType) : void {
        commit(SITE_LIST.RESET);
    }
};
